// src/i18n/en/liveBoard.ts
export const liveBoard = {
  name: 'Live board |||| Live board',
  subtitle: 'Who is waiting, who is at the kiosk, who needs help - right now',

  threshold: {
    label: 'Highlight after',
    helper: 'Personal preference - highlights a kiosk once it has spent longer than this on the same step.',
  },

  columns: {
    pending: 'Pending',
    atDevice: 'At the kiosk',
    atDeviceEmpty: 'Nobody at the kiosk right now.',
    needsHelp: 'Need someone',
    needsHelpEmpty: 'Nobody needs help right now.',
    roomNotReady: 'Waiting for room',
  },

  unknownDevice: 'Unidentified device',
  reservation: 'Reservation %{id}',

  signals: {
    blocking_error: 'Blocking error',
    handed_to_desk: 'Handed to desk',
  },

  deviceStrip: {
    title: 'Devices',
    empty: 'No registered devices.',
    silentSince: '%{label}: no signal %{relative}',
    silent: '%{label}: no signal',
    health: {
      up: 'In service',
      degraded: 'In service with warnings',
      down: 'Out of service: blocking fault',
      maintenance: 'Under maintenance',
      blocked: 'Blocked',
      unknown: 'No recent signal from this device.',
    },
  },

  todaySoFar: {
    title: 'Today so far',
    due: "Due (per the hotel's reservation system)",
    pre_checked: 'Pre-checked-in',
    not_yet_arrived: 'Not yet arrived',
    done: 'Done',
  },

  incidents: {
    title: 'Open incidents',
    empty: 'No open incidents.',
    open: 'Open',
    acknowledged: 'Acknowledged',
  },

  errorsNow: {
    title: 'Journeys with an error now',
    empty: 'No errors in progress.',
  },

  stamp: {
    updated: 'Updated %{relative}',
    noData: 'No data',
  },

  remedies: {
    R_FEED: "Data not available: this hotel does not receive its reservations from the hotel's reservation system. Turn on reservation delivery →",
    R_OUTBOX: 'Not available: this device\'s event delivery is not yet reliable. Update the kiosk software ->',
    R_N: 'Insufficient sample: fewer than 20 cases in the period.',
    R_PENDING: "Pending confirmation from the hotel's reservation system.",
    R_EVENTTIME: "Not available with the current connection: this hotel's reservation system is checked periodically and does not report its event times.",
    R_PMSFIELD: "This hotel's reservation system does not report this data.",
    R_SIGNAL: 'No signal for %{minutes} min.',
    R_MARKER: 'No chain reference: fewer than three hotels with data.',
    R_NO_BUSINESS_DAY_ROLLOVER: 'Business day not configured: this property has no defined day-close time.',
  },

  help: {
    title: 'Live board',
    description:
      'The reception board: four columns showing who is pending, at the kiosk, needing help or waiting for a room, plus the device strip and open incidents. Updates itself every 15 seconds; the "Refresh" button reads it at once.',
    features: {
      columns: '"Pending" and "Waiting for room" show only how many there are; "At the kiosk" and "Need someone" list each guest with an open journey.',
      deviceStrip: 'A grey device has gone a while without signal - it is never marked red for silence.',
      sound: 'A sound plays only when a new row appears in "Need someone", never for one already there.',
    },
    tips: {
      threshold: 'The minutes threshold is a personal preference of your user: it is saved to your account and follows you on any computer, but it is not a hotel setting and other receptionists do not see it.',
    },
  },
};

export default liveBoard;
